export const IconAttachment20: {
  name: 'icon_attachment_20-757a8e526308'
} = {
  name: 'icon_attachment_20-757a8e526308'
}
